// removed by extract-text-webpack-plugin
module.exports = {"container":"partials-links-container","item":"partials-links-item","link":"partials-links-link","social":"partials-links-social","icon":"partials-links-icon","facebook":"partials-links-facebook","twitter":"partials-links-twitter","vimeo":"partials-links-vimeo","instagram":"partials-links-instagram"};


//////////////////
// WEBPACK FOOTER
// ./styles/partials/links.scss
// module id = 883
// module chunks = 246